import { useQuery } from '@tanstack/react-query';

import { fetchUserSearch } from '../api';
import { type UserSearchRequest } from '../types';

import { DEBOUNCE_SEARCH_DELAY } from '@/components/SearchBar/SearchBar.hooks';
import { RQ_USER_SEARCH } from '@/modules/ReactQuery/cacheKeys';
import { useDebounce } from '@/modules/debounce/useDebounce';

export function useUserSearch({ enabled = true, query }: UserSearchRequest) {
  // TODO when experiment has concluded remove the isInExperiment arg and type from the UseSearchRequest
  const debouncedQuery = useDebounce(query, DEBOUNCE_SEARCH_DELAY);

  return useQuery({
    enabled,
    queryKey: [RQ_USER_SEARCH, debouncedQuery],
    queryFn: async () => {
      const res = await fetchUserSearch(debouncedQuery);

      if (!res) {
        return undefined;
      }
      return res.data;
    },
  });
}
